<div class="bottom-align">
  <ul class="horizontal-menu initial-changes heading-authoritiy-current ml-0 separator">
    <li
      class="font-lg date-time"
      [ngClass]="{
        inlinemob: !trackAuthorityChangeDetails?.multipleModifications
      }"
    >
      <span class="right-space" *ngIf="isAuthoritySharedModel">
        <strong> {{ '#' + ec1Number }} </strong>
      </span>
      <span class="font-bold date">
        {{ trackAuthorityChangeDetails?.changeTimeStamp | estDate | date: 'MM/dd/yyyy HH:mm' }}
      </span>
      <span class="sep">-</span>
      <span class="time" *ngIf="trackAuthorityChangeDetails?.changeText"> {{ trackAuthorityChangeDetails?.changeText }}</span>
    </li>
    <li
      *ngFor="let multipleModification of trackAuthorityChangeDetails?.multipleModifications; let i = index"
      [ngClass]="{ 'date-time': i === 0 }"
    >
      <span class="direction">{{ multipleModification }}</span>
    </li>
  </ul>
  <div class="initial-authority" *ngIf="isInitialAuthority">
    <ul class="horizontal-menu initial-changes heading-authoritiy-current ml-0 separator">
      <li>
        <label class="title">INITIAL AUTHORITY</label>
      </li>
    </ul>
  </div>
</div>

<div class="bottom-align">
  <ul class="horizontal-menu">
    <li *ngIf="trackAuthorityChangeDetails?.requestedBy && !trackAuthorityChangeDetails?.rejectedBy">
      <label class="sub-heading">Requested by:</label>
      {{ trackAuthorityChangeDetails?.requestedBy }}
    </li>
    <li *ngIf="trackAuthorityChangeDetails?.rejectedBy && isAuthoritySharedModel">
      <label class="sub-heading">Rejected by:</label>
      {{ trackAuthorityChangeDetails?.rejectedBy }}
    </li>
    <li *ngIf="trackAuthorityChangeDetails?.rejectionReason && isAuthoritySharedModel">
      <label class="sub-heading">Rejection Reason:</label>
      {{ trackAuthorityChangeDetails?.rejectionReason }}
    </li>
    <li>
      <label class="sub-heading" *ngIf="trackAuthorityChangeDetails?.dispatcher">Dispatcher:</label>
      {{ trackAuthorityChangeDetails?.dispatcher }}
    </li>
  </ul>
</div>
